const selectors = {
  form: '[data-back-in-stock-form]',
  modal: '[data-back-in-stock-modal]',
  trigger: '[data-back-in-stock-trigger]',
  close: '[data-back-in-stock-modal-close]',
  emailInput: '[data-back-in-stock-email]',
  errorMessage: '[data-back-in-stock-error]',
  productInput: '[data-back-in-stock-product]',
  submitButton: '[data-back-in-stock-submit]',
  successMessage: '[data-back-in-stock-success]',
  variantInput: '[data-back-in-stock-variant]',
};

const classes = {
  hidden: 'hidden',
  body: 'body',
  disable_scroll: 'overflow-hidden',
  disable_touch_scroll: 'touch-none',
};

class BackInStockForm {
  constructor() {
    this.body = document.querySelector(classes.body);
    this.form = document.querySelector(selectors.form);
    this.modal = document.querySelector(selectors.modal);
    this.trigger = document.querySelector(selectors.trigger) ?? false;
    this.close = document.querySelector(selectors.close);
    this.emailInput = document.querySelector(selectors.emailInput);
    this.errorMessageContainer = document.querySelector(selectors.errorMessage);
    this.productInput = document.querySelector(selectors.productInput);
    this.submitButton = document.querySelector(selectors.submitButton);
    this.successMessageContainer = document.querySelector(
      selectors.successMessage
    );
    this.variantInput = document.querySelector(selectors.variantInput);

    if (!this.trigger) {
      return;
    }

    console.log('this.trigger', this.trigger);

    this.registerEventListeners();
  }

  set variant(variant) {
    this.variantInput.value = variant.id;
  }

  registerEventListeners() {
    document.addEventListener('submit', event => this.onSubmit(event));
    this.close.addEventListener('click', () => {
      this.closeModal();
    });
    if (this.trigger) {
      this.trigger.addEventListener('click', e => {
        e.preventDefault();
        this.openModal();
      });
    }
    this.modal.addEventListener('click', e => {
      if (e.target === this.modal) this.closeModal();
    });
  }

  showErrorMessage() {
    this.errorMessageContainer.classList.remove(classes.hidden);
  }

  showSuccessMessage() {
    this.successMessageContainer.classList.remove(classes.hidden);
  }

  openModal() {
    this.modal.classList.remove(classes.hidden);
    this.disablePageScroll();
  }

  closeModal() {
    this.modal.classList.add(classes.hidden);
    this.enablePageScroll();
  }

  disablePageScroll() {
    this.body.classList.add(
      classes.disable_scroll,
      classes.disable_touch_scroll
    );
  }

  enablePageScroll() {
    this.body.classList.remove(
      classes.disable_scroll,
      classes.disable_touch_scroll
    );
  }

  onSubmit(event) {
    event.preventDefault();

    if (this.variantInput.value && this.productInput.value) {
      this.submitButton.disabled = true;

      fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
        headers: {
          accept: 'application/json, text/plain, */*',
          'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: new URLSearchParams({
          a: this.form.dataset.klaviyoKey,
          email: this.emailInput.value,
          platform: 'shopify',
          variant: this.variantInput.value,
          product: this.productInput.value,
        }),
        method: 'POST',
      }).then(response => {
        if (response.status >= 200 && response.status <= 299) {
          this.showSuccessMessage();
        } else {
          this.showErrorMessage();
          this.submitButton.disabled = false;
          throw Error(response.statusText);
        }
      });
    }
  }
}

const KlaviyoBackInStock = () => new BackInStockForm();
export default KlaviyoBackInStock;
